export class RegexHelper {

    public static regexDDD = /^[1-9]{2}$/;

    public static regexTelefone = /^([9]{1})?([0-9]{4})[-. ]?([0-9]{4})$/;

    public static regexMail = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w{2,3}([-.]\w+)*$/;
}


// WEBPACK FOOTER //
// ./src/app/shared/helpers/regex-helper.ts